import React from 'react';
import { useNotifications } from 'hooks/useNotifications';
import tw, { styled } from 'twin.macro';

const NotificationContainer = styled.div`
  ${tw`fixed z-50 max-w-sm`}
  top: 1rem;
  right: 1rem;
`;

const NotificationItem = styled.div`
  ${tw`p-4 rounded-lg shadow-lg transform transition-all duration-300 ease-in-out mb-2`}
  ${props => {
    switch (props.type) {
      case 'success':
        return tw`bg-green-500 text-white`;
      case 'error':
        return tw`bg-red-500 text-white`;
      case 'warning':
        return tw`bg-yellow-500 text-white`;
      default:
        return tw`bg-blue-500 text-white`;
    }
  }}
`;

const CloseButton = styled.button`
  ${tw`ml-4 text-white hover:text-gray-200 focus:outline-none`}
`;

const NotificationSystem = () => {
  const { notifications, removeNotification } = useNotifications();

  if (notifications.length === 0) return null;

  return (
    <NotificationContainer>
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} type={notification.type}>
          <div tw="flex items-center justify-between">
            <span>{notification.message}</span>
            <CloseButton
              onClick={() => removeNotification(notification.id)}
              aria-label="Close notification"
            >
              ×
            </CloseButton>
          </div>
        </NotificationItem>
      ))}
    </NotificationContainer>
  );
};

export default NotificationSystem;
